import { render } from "./HleBoqItemsApprovalBreakdown.vue?vue&type=template&id=77b3ff57"
import script from "./HleBoqItemsApprovalBreakdown.vue?vue&type=script&lang=js"
export * from "./HleBoqItemsApprovalBreakdown.vue?vue&type=script&lang=js"

import exportComponent from "/home/vsts/work/1/s/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__